/***运营商城***/
const routerOms = [
	{
        path: '/oms',
        name:'oms',
        meta: {
            show: true,
            title:'运营商城'
        },
        component: () => import('@/pages/oms/index')
    },
    {
        path: '/oms/mallproduct',
        name:'mallproduct',
        meta: {
            show: true,
            title:'商城产品'
        },
        component: () => import('@/pages/oms/mallproduct/index')
    },
    {
        path: '/oms/malloms',
        name:'malloms',
        meta: {
            show: true,
            title:'商城活动'
        },
        component: () => import('@/pages/oms/malloms/index')
    },
    {
        path: '/oms/special',
        name:'baoyaoSpecial',
        meta: {
            show: true,
            title:'特惠保养'
        },
        component: () => import('@/pages/oms/baoyang/special')
    },
    {
        path: '/oms/material',
        name:'omsMaterial',
        meta: {
            show: true,
            title:'素材管理'
        },
        component: () => import('@/pages/oms/stock/material')
    },
    {
        path: '/oms/debug',
        name:'omsDebug',
        meta: {
            show: true,
            title:'企微调试页'
        },
        component: () => import('@/pages/oms/qywx/debug')
    }
]

export {
	routerOms
}